// extracted by mini-css-extract-plugin
module.exports = {"popup":"DeGMb","width_widgetMedium":"_0zalo","width_mobileFull":"do5Qa"};